import { defineComponent as _defineComponent } from 'vue'
import { useForm } from '@/util/useForm';
import {  ref, watch } from 'vue';
import { postPointsProduct,delPointsProduct, editPointsProduct } from '../../api/points';
import { PointsProduct } from '../../type/points';
import { formatDate } from '@/util/global';
import lodash from 'lodash'

import SelectModel from './components/SelectProduct.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PointsProduct',
  setup(__props) {

const tableloading = ref<boolean>(false);

const queryParams = ref({});
async function query(params=queryParams.value) {
  tableloading.value=true
  const res = await postPointsProduct(params);
  tableloading.value=false

  if (res?.detail) {
    dataSource.value = res?.detail;
    pagination.value = {
      total: res?.total,
      current: res?.current,
      pageSize: res?.limit,
      showTotal: () => `共${res.total}条，每页${res.limit}条`,
    };
  } else {
    dataSource.value = [];
    pagination.value = {
      total: res?.total||1,
      current: 1,
      pageSize: res?.limit||10,
      showTotal: () => `共${res?.total||1}条，每页${res?.limit||10}条`,
    };
  }
}
//检查查询参数变化请求接口刷新数据
watch(
  queryParams,
  (newVal,oldVal) => {    
    query(newVal||undefined);
  },
  { immediate: true }
);
const form = useForm();
//表单提交
function submit(e) {
  //移除表单提交默认事件
  e.preventDefault();
  const formdata = form.value.getFormValue();
  queryParams.value = {
    ...queryParams.value,
    current: 1,
    ...formdata,
  };
}
//重置表单
function clearForm() {
  form.value.resetFields();
  queryParams.value = { current: 1 };
}

const dataSource = ref<PointsProduct[]>([]);
const pagination = ref<{
  current: number;
  total: number;
  pageSize: number;
  showTotal: () => string;
}>();
function onPagination(page: { current: number; pageSize: number; showTotal: any; total: number }) {
  queryParams.value = {
    ...queryParams.value,
    current: page.current,
  };
}
const editKeys= ref<number|undefined>()
let restore: any|undefined = undefined
function edit(product: PointsProduct){
  restore =  lodash.cloneDeep( dataSource.value)
   if(product.id){
    editKeys.value = product.id
    }
}
async function save(product: PointsProduct){
     console.log(product);
     if(await editPointsProduct(product.id,product?.points)){
        query()
     }else{
      cancel()
     }
    editKeys.value =undefined
}
function cancel(product?: PointsProduct){
     dataSource.value = restore
     editKeys.value =undefined
}

async function remove(product: PointsProduct){
    if(product.id){
        await delPointsProduct(product.id)
        query()
    }
}


return { __sfc: true,tableloading, queryParams, query, form, submit, clearForm, dataSource, pagination, onPagination, editKeys, restore, edit, save, cancel, remove, formatDate, SelectModel }
}

})